export default function getGaClientId() {
  try {
    return window.ga.getAll()[0].get('clientId');
  } catch {
    //
  }

  return null;
}
